import React from 'react'
import { Routes, Route, useNavigate, useParams } from 'react-router-dom'
import { useNavigate, useParams } from 'react-router-dom'

import CircularProgress from '@mui/material/CircularProgress'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Alert from '@mui/material/Alert'
import { DataGrid } from '@mui/x-data-grid'
import FormControlLabel from '@mui/material/FormControlLabel'
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'


import useStateObject from '~/client/hooks/useStateObject'
import { useQuery, useCommand } from '~/client/hooks/cqrpc'
import useToggle from '~/client/hooks/useToggle'

import Link from '~/client/components/Link'
import ButtonRow from '~/client/components/ButtonRow'
import ErrorMessage from '~/client/components/ErrorMessage'
import DocumentTypeCreateForm from '~/client/components/DocumentTypeCreateForm'
import Timestamp from '~/client/components/Timestamp'
import LoadingList from '~/client/components/LoadingList'
import DocumentTypeFormPreview from '~/client/components/DocumentTypeFormPreview'

import InspectObject from '~/client/components/InspectObject'


export default function Page(props) {

  const query = useQuery('documentTypes.getAll')
  const documentTypes = query.result || []
  return <Container>
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography my={2} variant="h3">Document Types</Typography>
      <Button
        variant="outlined"
        component={Link}
        to="/documents/types/new"
      >create new document type</Button>
    </Stack>

    <TableContainer>
      <Table sx={{
        minWidth: 650,
        maxWidth: '100%',
        whiteSpace: 'nowrap',
      }}>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Description</TableCell>
            <TableCell align="right">Created At</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {documentTypes.map(documentType => (
            <TableRow
              key={documentType.id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                <Link to={`/documents/types/${documentType.id}`}>
                  {documentType.name}
                </Link>
              </TableCell>
              <TableCell>
                <Typography sx={{
                  maxWidth: '40vw',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}>{documentType.description}</Typography>
              </TableCell>
              <TableCell align="right">
                <Timestamp at={documentType.createdAt}/>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Container>
}


function Show({ }){
  const { id } = useParams()
  const query = useQuery('documentTypes.getById', { id })
  const documentType = query.result
  const [tab, setTab] = React.useState('preview')
  return <Paper sx={{p: 2, my: 1}}>
    <ErrorMessage error={query.error}/>
    {query.pending ? <CircularProgress/> : null}
    {documentType
      ? <>
        <Typography variant="h6">Name: {documentType.name}</Typography>
        <Typography
          variant="body2"
          component="p"
          sx={{whiteSpace: 'pre-wrap'}}
        >{documentType.description}</Typography>
        <Tabs
          variant="fullWidth"
          value={tab}
          onChange={(e,v) => setTab(v)}
          sx={{mb:1}}
        >
          <Tab label="PREVIEW FORM" value="preview"/>
          <Tab label="SCHEMA" value="schema" />
        </Tabs>
        {tab === 'preview'
          ? <Box sx={{p: 4}}>
            <DocumentTypeFormPreview {...{documentType}}/>
          </Box>
          : null
        }
        {tab === 'schema'
          ? <Box sx={{
            backgroundColor: 'background.paper',
            whiteSpace: 'pre-wrap',
            p: 2,
            fontFamily: 'monospace',
          }}>{JSON.stringify(documentType.schema, null, 2)}</Box>
          : null
        }
      </>
      : null
    }
  </Paper>
}

function New(){
  const navigate = useNavigate()
  const create = useCommand('documentTypes.create', {
    onSuccess(documentType){
      navigate(`/documents/types/${documentType.id}`)
    }
  })
  const [value, onChange] = React.useState({
    name: '',
    description: '',
    schema: '',
  })
  console.log('NEW PAGE VALUE', value)
  return <Paper sx={{p: 2, my: 1}}>
    <Typography variant="h6">New Document Type</Typography>
    <DocumentTypeCreateForm {...{
      value,
      onChange,
      onSubmit(){
        const {name, description, schema} = value
        create.call({
          name,
          description,
          schema,
        })
      },
      submitting: create.pending,
      error: create.error,
    }}/>
  </Paper>
}
